import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { GetPartnershipFailure, GetPartnershipRequest, GetPartnershipSuccess } from './actions';
import { ConfiguratorPartnership } from '@models';

export const featureKey = 'getPartnership';

export interface State {
  data: ConfiguratorPartnership | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(GetPartnershipFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(GetPartnershipRequest, state => ({ ...state, error: null, loading: true })),
    on(GetPartnershipSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
